import {Component, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {WhatIsAnimaCloseAction, WhatIsAnimaModalComponent} from '../../what-is-anima-modal/what-is-anima-modal.component';
import {AuthService} from '../../../../../../firebase/src/lib/services/auth.service';
import {AuthComponent} from '../../auth/auth.component';
import {PayedService} from '../../../services/payed.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-home-hero-ai-landing',
    templateUrl: './home-hero-ai-landing.component.html',
    styleUrls: ['./home-hero-ai-landing.component.scss']
})
export class HomeHeroAiLandingComponent implements OnInit {

    constructor(
        private modalService: NgbModal,
        private router: Router,
        public auth: AuthService,
        public payed: PayedService,
        private deviceService: DeviceDetectorService,

    ) {
    }

    ngOnInit(): void {
    }
    get isMobile() {
        return this.deviceService.isMobile();
    }
    startTest() {
        if (this.isLoggedIn) {
            this.goToTest();
        } else {
            this.openAuthModal(true);
        }
    }

    get isLoggedIn(): boolean {
        return this.auth?.isLoggedIn;
    }

    openAuthModal(goToCs?: boolean) {
        const modalRef = this.modalService.open(AuthComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });
        modalRef.componentInstance.data = {};
        modalRef.result.then(
            (res: any) => {
                if (res && goToCs) {
                    this.goToTest();
                }
            },
            () => {
                // this.fetchLockedSlots();
            }
        );
    }

    openWhatIsModal() {
        const modalRef = this.modalService.open(WhatIsAnimaModalComponent, {
            centered: true,
            windowClass: 'modal what-is-anima bg-transparent',
            backdrop: true,
            keyboard: true
        });
        modalRef.componentInstance.videoId = 'tXM9LNIXh9Q';
        modalRef.result.then(
            (res) => {
                if (res === WhatIsAnimaCloseAction.startTest) {
                    return this.startTest();
                }
            }
        );
    }

    async goToTest() {
        return this.router.navigate(
            [ this.payed.isPayed() ? '/cs' : '/pricing'],
        );
    }


}
